var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQ1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4217 15.9335C18.8707 23.9939 11.8981 33.3756 10.5038 44.0784C8.3332 60.7402 23.2335 68.8957 30.7833 61.5681C38.3332 54.2404 33.8075 44.9396 28.3407 42.3972C22.8738 39.8547 19.5307 40.7402 20.1138 37.3427C20.697 33.9454 28.4747 24.5257 35.3077 20.1389C35.761 19.7534 35.9335 19.0054 35.497 18.4379C35.2098 18.0647 34.6467 17.3328 33.8075 16.2421C33.0737 15.2883 32.3707 15.324 31.4217 15.9335Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4646 15.9335C51.9137 23.9939 44.9411 33.3756 43.5467 44.0784C41.3762 60.7402 56.2766 68.8957 63.8264 61.5681C71.3762 54.2404 66.8506 44.9396 61.3837 42.3972C55.9169 39.8547 52.5736 40.7402 53.1569 37.3427C53.7401 33.9454 61.5177 24.5257 68.3507 20.1389C68.8041 19.7534 68.9766 19.0054 68.5399 18.4379C68.2529 18.0647 67.6897 17.3328 66.8506 16.2421C66.1167 15.2883 65.4137 15.324 64.4646 15.9335Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ1);
export default __webpack_public_path__ + "static/media/q1.1c6b8670a849ae0b94515df4a9279d94.svg";
export { ForwardRef as ReactComponent };